module.exports = __webpack_public_path__ + "img/dubai.8b64b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/offices/dubai.png
// module id = 1808
// module chunks = 1